module.exports = __webpack_public_path__ + "media/images/official/special_migration_07-f3648b692847fae7490c54ed29e6695d.jpg";